<template functional>
  <div>
    <div
      v-for="flag in (props.row.flags || [])"
      :key="flag.id"
      class="flex flex-wrap"
    >
      <span
        class="inline-block px-2 py-1 mb-1 mr-1 text-sm text-white whitespace-no-wrap rounded-full"
        :style="{ backgroundColor: flag.item_color || '#ccc' }"
      >
        {{ flag.item_title }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MiaCarSearchDatatableFlagsColumn',

  props: {
    row: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>
